import { get, getAll } from "../utilities/querySelector";
import TweenMax from "gsap";

const parallaxElems = getAll("[data-parallax]");

if (parallaxElems.length) {
    parallaxElems.forEach((elem) => {
        elem.addEventListener("mousemove", function (e) {
            // console.log(elem);
            parallaxIt(e, elem, 35);
        });
    });

    function parallaxIt(e, target, movement) {
        // console.log(target);
        const $this = jQuery(target);
        // console.log($this);
        const relX = e.pageX - $this.offset().left;
        const relY = e.pageY - $this.offset().top;
        // console.log(relX, relY);

        TweenMax.to(target, {
            // Default
            duration: 1,
            x: ((relX - $this.width() / 2) / $this.width()) * movement - 10,
            y: ((relY - $this.height() / 2) / $this.height()) * movement,
        });
    }
}
